import React from 'react';
import { Button, Typography } from '@mui/material';
import DialogModal from '../../../components/DialogModal';
import { DeleteOrUnlinkBusDialogProps, BusAction } from '../types/busTypes';
import {
  deleteBusById,
  getConfirmationText,
  getConfirmButtonLabel,
  getDialogTitle,
  getErrorMessage,
  getSuccessMessage,
  unlinkDeviceFromBus
} from '../utils/utils';
import { SnackbarSeverityType } from '../../../enums';

const DeleteOrUnlinkBusDialog: React.FC<DeleteOrUnlinkBusDialogProps> = ({
  open,
  action,
  bus,
  loading = false,
  onCancel,
  onCompleted,
  showToast
}) => {
  const handleConfirm = async () => {
    if (!bus || !action) return;
    try {
      if (action === BusAction.delete) {
        await deleteBusById(bus);
      } else {
        await unlinkDeviceFromBus(bus);
      }
      showToast(getSuccessMessage(action), SnackbarSeverityType.success);
      onCompleted();
    } catch (e: any) {
      showToast(
        getErrorMessage(action, e?.message),
        SnackbarSeverityType.error
      );
    }
  };

  const title = getDialogTitle(action);
  const bodyText = getConfirmationText(action);
  const confirmLabel = getConfirmButtonLabel(action);

  return (
    <DialogModal
      open={open}
      onClose={onCancel}
      title={title}
      actions={
        <>
          <Button variant='contained' onClick={onCancel} disabled={loading}>
            Cancel
          </Button>
          <Button
            variant='contained'
            color={action === BusAction.delete ? 'error' : 'primary'}
            disabled={!bus || loading}
            onClick={handleConfirm}
          >
            {confirmLabel}
          </Button>
        </>
      }
    >
      {bodyText && bus && <Typography>{bodyText}</Typography>}
    </DialogModal>
  );
};

export default DeleteOrUnlinkBusDialog;
